import styled, { css } from 'styled-components';

export const ProgressChecklistWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  ${({ theme }) => theme.breakpoints.sm.query} {
    padding: 0 24px;
  }
`;

export const ProgressChecklistContainer = styled.div<{ $hasText: boolean }>`
  display: flex;
  justify-content: center;
  width: 100%;
  ${({ $hasText }) =>
    $hasText &&
    css`
      padding-bottom: 32px;
    `}
`;

export const StepWrapper = styled.div``;

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 550;
  max-width: 150px;
  width: 0;
  flex: 1 1 0;
  gap: 12px;
  position: relative;

  ${({ theme }) => theme.breakpoints.sm.query} {
    width: 100%;
  }
`;

export const StepLabel = styled.span`
  color: ${({ theme }) => theme.colors.default[200]};
  transition: 0.2s;
  position: relative;
  text-align: center;
  white-space: nowrap;
  ${({ theme }) => theme.breakpoints.sm.query} {
    position: absolute;
    white-space: pre-wrap;
    top: calc(100% + 6px);
  }
`;

export const StepDivider = styled.span<{ $selected: boolean }>`
  width: calc(100% - 48px);
  transform: translateX(-50%);
  left: calc(50% - 6px);
  background: ${({ theme }) => theme.colors.default[100]};
  z-index: 3;
  height: 3px;
  display: block;
  position: relative;
  top: 12px;
  border-radius: 4px;
  overflow: clip;

  &::after {
    transition: 0.2s ease-out;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-width: ${({ $selected }) => ($selected ? '100%' : 0)};
    height: 100%;
    background: ${({ theme }) => theme.colors.primary.default};
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    left: calc(50% - 21px);
  }
`;

export const StepOverWrapper = styled.div<{ $selected: boolean }>`
  display: flex;
  gap: 4px;
  max-width: 150px;
  width: 100%;
  position: relative;

  &:last-of-type {
    max-width: revert;
    width: fit-content;
  }

  ${({ $selected, theme }) =>
    $selected &&
    css`
      ${StepLabel} {
        color: ${theme.colors.primary.default};
      }
    `}
`;
